import React from "react";
import {
  HeroSection,
  ServicesSection,
  WhyChooseUsSection,
  CTASection,
} from "../components";
import { RecognitionSection } from "../components/RecognitionSection";

export const Home: React.FC = () => {
  return (
    <>
      <HeroSection />
      <ServicesSection />
      <WhyChooseUsSection />
      <CTASection />
      <RecognitionSection />
    </>
  );
};
